<template>
  <div class="inter-hospital">
    <div class="hospital-content padding-main mobile-padding">
      <el-row>
        <el-col :xs="24"
                :sm="24"
                :md="8"
                class="hospital-desc">
          <div class="hospital-title">{{ $t('interHospital.yyInterHospital') }}</div>
          <!-- <div class="hospital-tip hidden-md-and-up">{{ $t('interHospital.yyInterHospitalTip1') }}<span>{{ $t('interHospital.yyInterHospitalTip2') }}</span></div> -->
          <div class="hospital-tip">{{ $t('interHospital.yyInterHospitalTip') }}</div>
          <div class="hospital-btn hidden-sm-and-down">
            <!-- <div v-for="(item,index) in btnList"
                 :class="index===2?'change-color':''"
                 :key="index"
                 class="btn-item"
                 @click.stop="jumpPage(item)">v<i class="el-icon-arrow-right" /></div> -->
            <el-button v-for="(item,index) in btnList"
                       :key="index"
                       :type="index===4?'info':'primary'"
                       size="medium"
                       round
                       class="btn-item"
                       @click.stop="jumpPage(item)">{{ item.name }}
              <i class="el-icon-arrow-right" />
            </el-button>
          </div>
          <div class="qr-code hidden-sm-and-down">
            <el-image style="width: 117px; height: 117px"
                      src="/img/yy_hospital_mini.jpg"
                      fit="cover" />
            <div>{{ $t('interHospital.yyInterHospital') }}</div>
          </div>
        </el-col>
        <el-col :xs="24"
                :sm="24"
                :md="16"
                style="text-align: right;">
          <div class="image-flex">
            <el-image class="hospital-image"
                      src="/img/inter_hospital.png"
                      fit="cover" />
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="hospital-scheme padding-main-new mobile-padding">
      <div class="title">{{ $t('interHospital.interHospitalSolution') }}</div>
      <div class="content">
        <div v-for="(item,index) in schemeList"
             :key="index"
             class="scheme-item">
          <div class="item-image">
            <el-image :src="item.icon"
                      fit="cover" />
          </div>
          <div class="item-title">{{ item.title }}</div>
          <div class="item-tip">{{ item.tip }}</div>
        </div>
      </div>
    </div>
    <div class="hospital-recipe padding-main-new mobile-padding">
      <div class="title">{{ $t('interHospital.recipeForStore') }}</div>
      <div class="content">
        <div v-for="(item,index) in provideRecipeList"
             :key="index"
             :style="{backgroundImage: `url(${item.backgroundImg})`}"
             class="recipe-item">
          <div class="item-image">
            <el-image :src="item.icon"
                      fit="cover" />
          </div>
          <div class="item-title">{{ item.title }}</div>
          <div class="item-tip">{{ item.tip }}</div>
        </div>
      </div>
    </div>
    <div class="hospital-construct padding-main-new mobile-padding">
      <div class="title">{{ $t('interHospital.constructForHospital') }}</div>
      <div class="content">
        <div v-for="(item,index) in constructList"
             :key="index">
          <div class="construct-item">
            <div class="item-image">
              <el-image :src="item.icon"
                        fit="cover" />
            </div>
            <div class="item-info">
              <div class="item-title">{{ item.title }}</div>
              <div class="item-tip">{{ item.tip }}</div>
            </div>
          </div>
          <div v-if="index !== constructList.length-1"
               class="construct-icon hidden-md-and-up"><i class="el-icon-arrow-down" /></div>
        </div>
      </div>
    </div>
    <div class="hospital-flow padding-main-new mobile-padding">
      <div class="title">{{ $t('interHospital.recipeFlowPlatform') }}</div>
      <div class="title1">{{ $t('interHospital.recipeFlowPlatformTip2') }}</div>
      <el-image src="/svg/recipe_flow.svg"
                fit="cover" />
    </div>
  </div>
</template>

<script>
import { interHospitalObj } from '@/const/crud/list'
import { vaildatePc } from '@/commonModule/utils/validate'

export default {
  name: 'InterHospital',
  data() {
    return {
      vaildatePc,
      btnList: interHospitalObj.btnList,
      hospitalList: interHospitalObj.hospitalList,
      schemeList: interHospitalObj.schemeList,
      provideRecipeList: interHospitalObj.provideRecipeList,
      constructList: interHospitalObj.constructList
    }
  },
  methods: {
    jumpPage(item) {
      if (item.url) {
        window.open(item.url, '_blank')
      } else {
        this.$message.warning(this.$t('common.noTip'))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/mixin.scss';

.padding-main-new {
  padding: 3.125vw 18.75vw;
}

.image-flex {
  height: 100%;
  @include wrap-flex;
}

.el-row,
.el-col {
  height: 100%;
}

.title {
  text-align: center;
  font-size: 30px;
  font-weight: bold;
}

.inter-hospital {
  .hospital-content {
    background-color: $bgColor;
    height: 39.06vw;
    min-height: 600px;
    .hospital-desc {
      align-items: flex-start;
      .hospital-title {
        font-size: 44px;
        margin-top: 7.29vw;
        font-weight: bold;
        margin-bottom: 0.72vw;
      }
      .hospital-tip {
        font-size: 18px;
        margin-bottom: 1.56vw;
      }
      .hospital-btn {
        // display: flex;
        // flex-wrap: wrap;
        width: 90%;
        .btn-item {
          width: 94px;
          margin: 0;
          margin-right: 1.04vw;
          margin-bottom: 1.04vw;
          background-color: $mainColor;
          cursor: pointer;
          font-size: 16px;
          height: 36px;
          padding: 0px 16px;
          i {
            margin-left: 2px;
            vertical-align: -1px;
          }
        }
        .el-button--info {
          background-color: #909399;
          border-color: #909399;
        }
      }
      .qr-code {
        width: 117px;
        margin-top: 0.52vw;
        div {
          font-size: 14px;
          text-align: center;
        }
      }
    }
  }
  .hospital-scheme {
    height: $sessionHeight;
    .content {
      display: flex;
      justify-content: space-between;
      margin-top: 7.395vw;
      .scheme-item {
        width: 19.8vw;
        height: 25vw;
        box-shadow: 0 10px 20px 6px rgba(228, 228, 228, 0.5);
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 5.2vw 15px 0;
        .item-image {
          margin-bottom: 2.34vw;
        }
        .item-title {
          margin-bottom: 12px;
          font-size: 1.25vw;
          font-weight: bold;
        }
        .item-tip {
          text-align: center;
          font-size: 14px;
          width: 100%;
        }
      }
    }
  }
  .hospital-recipe {
    height: 40vw;
    background: #f7fcfe;
    .content {
      display: flex;
      justify-content: space-between;
      margin-top: 4.68vw;
      .recipe-item {
        border-radius: 50%;
        width: 19.8vw;
        height: 19.8vw;
        box-shadow: 0 10px 20px 6px rgba(228, 228, 228, 0.5);
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 5.2vw 4.2vw 0;
        background-repeat: no-repeat;
        background-size: cover;
        .item-image {
          margin-bottom: 1vw;
        }
        .item-title {
          margin-bottom: 12px;
          font-size: 1.25vw;
          font-weight: bold;
        }
        .item-tip {
          text-align: center;
          font-size: 14px;
        }
      }
    }
  }
  .hospital-construct {
    height: 40vw;
    .content {
      display: flex;
      justify-content: space-between;
      margin-top: 7.29vw;
      .construct-item {
        border-radius: 50%;
        width: 11.45vw;
        height: 14.58vw;
        border: 1px solid #f7fcfe;
        box-shadow: 0 10px 20px 6px rgba(228, 228, 228, 0.5);
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 3.125vw 10px 0;
        .item-image {
          margin-bottom: 1.04vw;
        }
        .item-info {
          text-align: center;
        }
        .item-title {
          margin-bottom: 12px;
          font-size: 1.04vw;
          font-weight: bold;
        }
        .item-tip {
          text-align: center;
          font-size: 14px;
          width: 100%;
        }
      }
    }
  }

  .hospital-flow {
    height: $sessionHeight;
    text-align: center;
    background: #f7fcfe;
    .title {
      margin-bottom: 1.04vw;
    }
    .title1 {
      margin-bottom: 5.2vw;
    }
    .el-image {
      width: 37.5vw;
    }
  }
}
@media screen and (max-width: 1440px) {
  .hospital-scheme {
    .scheme-item {
      padding-top: 3.2vw !important;
      .item-image {
        width: 8.88vw;
        margin-bottom: 1.34vw !important;
      }
    }
  }
  .hospital-recipe {
    .recipe-item {
      padding-top: 3.2vw !important;
    }
  }
  .hospital-construct {
    .construct-item {
      padding-top: 1.2vw !important;
    }
  }
}
@media screen and (max-width: 992px) {
  .el-col {
    height: auto;
  }
  .mobile-padding {
    height: auto !important;
    padding: 5.33vw $mobilePadding !important;
  }
  .title {
    font-size: 4.27vw;
  }
  .inter-hospital {
    .hospital-content {
      height: 106.67vw !important;
      padding: 5.33vw 0 !important;
      text-align: center;
      min-height: auto;
      .hospital-desc {
        padding: 0 $mobilePadding;
        .hospital-title {
          font-size: $mobileFontSize;
          margin-bottom: 1.33vw;
        }
        .hospital-tip {
          background-color: $bgColor;
          font-size: $mobileFontSize;
          color: #333;
          width: auto;
          span {
            color: $mainColor;
          }
        }
      }
      .hospital-image {
        margin-top: 13.33vw;
        width: 100%;
      }
    }
    .hospital-scheme {
      height: auto !important;
      .content {
        display: block;
        .scheme-item {
          padding: 5.33vw 3.2vw;
          width: 100%;
          height: auto;
          margin-bottom: 3.2vw;
          box-shadow: 0 10px 20px 6px rgba(228, 228, 228, 0.5);
          .item-image {
            width: 21.33vw;
            margin-bottom: 3.73vw;
            .el-image {
              width: 100%;
            }
          }
          .item-title {
            font-size: $mobileFontSize;
            margin-top: 0vw;
            margin-bottom: 1.33vw;
          }
          .item-tip {
            font-size: $mobileFontSize;
          }
        }
      }
    }
    .hospital-recipe {
      height: auto !important;
      .content {
        display: block;
        .recipe-item {
          padding: 10.67vw !important;
          width: 64.53vw;
          height: 64.53vw;
          margin: 0 auto;
          margin-bottom: 3.2vw;
          .item-image {
            width: 11.2vw;
            margin-bottom: 3.73vw;
            .el-image {
              width: 100%;
            }
          }
          .item-title {
            font-size: $mobileFontSize;
            margin-top: 0vw;
            margin-bottom: 1.33vw;
          }
          .item-tip {
            font-size: $mobileFontSize;
          }
        }
      }
    }
    .hospital-construct {
      height: auto !important;
      .content {
        display: block;
        .construct-item {
          padding: 5.33vw 8.33vw !important;
          width: 100%;
          height: 37.33vw;
          flex-direction: row;
          .item-image {
            width: 11.2vw;
            margin-right: 9.06vw;
            .el-image {
              width: 100%;
            }
          }
          .item-info {
            text-align: left;
          }
          .item-title {
            font-size: 4.27vw;
            margin-top: 0vw;
            margin-bottom: 1.33vw;
          }
          .item-tip {
            font-size: $mobileFontSize;
            text-align: left;
          }
        }
        .construct-icon {
          margin: 3.2vw 0;
          text-align: center;
          i {
            font-size: 3.2vw;
            color: #3b94ff;
            font-weight: bold;
          }
        }
      }
    }
    .hospital-flow {
      height: auto !important;
      .title {
        margin-bottom: 1.04vw;
      }
      .title1 {
        font-size: 3.73vw;
        margin-bottom: 5.2vw;
      }
      .el-image {
        width: 100%;
      }
    }
  }
}
</style>
